var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"ma-6 pa-6",attrs:{"outlined":""}},[_c('DiligenceFilter',{on:{"onFilterChanged":_vm.refresh}})],1),_c('v-card',{staticClass:"ma-6",attrs:{"outlined":""}},[_c('DiligenceDataTable',{ref:"diligence-data-table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }